import React, { useState } from "react";
import { collection, query, where, getDocs } from "firebase/firestore";
import { fireDB } from "../../../../Backend/Firebase/FirebaseConfigData"; // Assuming your Firebase config is correct

interface RowData {
  name: string;
  coursename: string;
  totalduration: string;
  completionmonth: string;
  completionyear: string;

}

const VerificationForm: React.FC = () => {
  const [verificationCode, setVerificationCode] = useState<string>(""); // State for validation code input
  const [data, setData] = useState<RowData | null>(null); // State for storing fetched data
  const [error, setError] = useState<string | null>(null); // State for error handling

  // Fetch data from Firestore based on the entered verification code
  const fetchData = async () => {
    setError(null); // Clear error
    setData(null); // Clear previously fetched data

    try {
      // Reference to the Firestore collection where certificate data is stored
      const certificatesRef = collection(fireDB, "Certificates"); // Collection name is "certificates"
      
      // Query Firestore to find the document that matches the entered verification code (uid)
      const q = query(certificatesRef, where("uid", "==", verificationCode)); // Use uid to match the validation code

      const querySnapshot = await getDocs(q); // Fetch the documents matching the query

      if (!querySnapshot.empty) {
        // If documents are found, get the first one (assuming there's only one match)
        const doc = querySnapshot.docs[0].data();
        console.log("Document found:", doc); // Log the document data to the console

        // Set the fetched data to state
        setData({
          name: doc.name,
          coursename: doc.coursename,
          totalduration: doc.totalduration,
          completionmonth: doc.completionmonth,
          completionyear: doc.completionyear,
         
        });
      } else {
        // If no document matches, set an error and log it to the console
        setError("Invalid validation code. Please contact the Admin.");
        console.error("No matching document found for UID:", verificationCode);
      }
    } catch (err) {
      // If an error occurs while fetching data, set an error message and log the error to the console
      setError("An error occurred while fetching data.");
      console.error("Error during Firestore fetch:", err); // Log the error for debugging
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
      <div className="bg-white shadow-2xl rounded-lg p-6 w-full max-w-4xl">
        <div className="bg-orange-500 h-2 rounded-t-lg"></div>
        <div className="flex flex-col sm:flex-row justify-between items-center border-b pb-4 mb-6 pt-4 px-4 bg-gray-300">
          <h1 className="text-2xl font-bold text-blue-600">Credential Verification</h1>
        </div>
        <p className="text-center mb-4 text-gray-600 text-xl font-semibold">
          Please enter a validation code below.
        </p>
        <div className="flex flex-col items-center gap-4">
          <input
            type="text"
            value={verificationCode}
            onChange={(e) => setVerificationCode(e.target.value)}
            placeholder="Validation Code*"
            className="w-full max-w-md border text-black border-gray-800 bg-gray-50 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-400"
          />
          <button
            onClick={fetchData}
            className="w-full max-w-xs bg-orange-500 text-white py-3 rounded-md hover:bg-orange-600 text-lg font-semibold"
          >
            VERIFY CREDENTIAL
          </button>
        </div>

        {error && <p className="text-red-500 text-center mt-4">{error}</p>}

        {data && (
          <div className="mt-6 bg-white shadow-xl border border-gray-300 p-6 rounded-lg">
          <h2 className="text-2xl font-semibold text-gray-800 text-center mb-4">Certificate Details</h2>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <p className="text-lg text-black underline font-bold">Student Name:</p>
              <p className="text-xl font-semibold text-green-700">{data.name}</p>
            </div>
        
            <div>
              <p className="text-lg text-black underline font-bold">Course Name:</p>
              <p className="text-xl font-semibold text-green-700">{data.coursename}</p>
            </div>
        
            <div>
              <p className="text-lg text-black underline font-bold">Total Duration:</p>
              <p className="text-xl font-semibold text-green-700">{data.totalduration} months</p>
            </div>
        
            <div>
              <p className="text-lg text-black underline font-bold">Completion Month:</p>
              <p className="text-xl font-semibold text-green-700">{data.completionmonth}</p>
            </div>
        
            <div>
              <p className="text-lg text-black underline font-bold">Completion Year:</p>
              <p className="text-xl font-semibold text-green-700">{data.completionyear}</p>
            </div>
          </div>
        </div>
        
        )}
      </div>
    </div>
  );
};

export default VerificationForm;
